export const SIGNING_CONTRACTS_STATUSES: string[] = [
  'RETURNED_BY_CONTRACTING',
  'DOCS_WITH_CUSTOMER',
  'EDOCS_SIGNED',
];
